import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SelectButton } from 'primereact/selectbutton';
import { ProgressSpinner } from 'primereact/progressspinner';
import { translatedMessage } from '../../service/LanguageService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CompetitionUtils from '../../utilities/CompetitionUtils';
import SecurityService from '../../service/SecurityService';

const CompetitionToolbar = (props) => {
    const [competition, setCompetition] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const _sections = [
        { label: translatedMessage('generic.details'), code: 'DETAIL', icon: 'fa-regular fa-eye', url: "/" },
        { label: translatedMessage('competition.calendar'), code: 'CALENDAR', icon: 'fa-regular fa-calendar', url: "/calendar" },
        { label: translatedMessage('competition.jobs'), code: 'JOB', icon: 'fa-regular fa-address-card', url: "/job" },
        { label: translatedMessage('competition.requirements'), code: 'REQ', icon: 'fa-regular fa-file-lines', url: "/requirement" },
        { label: translatedMessage('competition.document.title'), code: 'DOCUMENT', icon: 'fa-solid fa-paperclip', url: "/document" },
        { label: translatedMessage('competition.committees'), code: 'COMMITTEE', icon: 'fa-solid fa-user-group', url: "/committee" },
        { label: translatedMessage('competition.form'), code: 'FORM', icon: 'fa-regular fa-file-lines', url: `/form/${props?.competition?.form?.id}` },
        { label: translatedMessage('competition.testCenters'), code: 'TEST_CENTER', icon: 'fa-regular fa-building', url: "/test-center" },
        { label: translatedMessage('competition.tests'), code: 'TEST', icon: 'fa-solid fa-list-check', url: "/test" },
        { label: translatedMessage('competition.subjects'), code: 'SUBJECT', icon: 'fa-solid fa-list-check', url: '/subject'},
        { label: translatedMessage('generic.backToList'), code: 'BACK', icon: 'fa-solid fa-arrow-left' }
    ];

    let _section = props ? _sections.filter(item => item.code === props.code)[0] : _sections[0];
    const [section, setSection] = useState(_section);
    const [sections, setSections] = useState(_sections);


    const navigate = useNavigate();

    useEffect(() => {
        const updateJobCompetitionSections = () => {
            let enabledSections = _sections.filter((item) => item.code !== 'TEST_CENTER' && item.code !== 'TEST' && item.code !== 'FORM');
            setSections(enabledSections);

            SecurityService.check('CAN_VIEW_SUBJECTS', props?.competition?.id).then((hasPermission) => {
                if (!hasPermission) {
                    enabledSections = enabledSections.filter((section) => section.code !== 'SUBJECT');
                    setSections(enabledSections);
                }
            });
        };

        setCompetition(props?.competition)
        if (props?.competition) {
            if (CompetitionUtils.isJobCompetition(props?.competition?.type)) {
                updateJobCompetitionSections();
            } else {
                let enabledSections = CompetitionUtils.isOfflineCompetition(props?.competition?.type)
                    ? _sections.filter((item) => !['CALENDAR', 'JOB', 'REQ', 'DOCUMENT', 'SUBJECT', 'TEST_CENTER', 'TEST'].includes(item.code))
                    : _sections.filter((item) => !['CALENDAR', 'JOB', 'REQ', 'DOCUMENT', 'SUBJECT'].includes(item.code));
                setSections(enabledSections);
            }
        }

        setIsLoading(false);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props]);

    const navigationTemplate = (option) => {
        return (
            <div className='flex align-items-center'>
                <FontAwesomeIcon icon={option.icon} className="mr-1 " />
                <span>{option.label}</span>
            </div>
        )
    }

    const handleSelectButtonChange = (value) => {
        let url = null
        if (value) {
            if (value.code === 'BACK') {
                navigate(CompetitionUtils.isNationalCompetition(competition?.type) ? `/competition` : `/competition-job`);
            } else {
                if (value && value.url && value.url !== '#') {
                    url = (CompetitionUtils.isNationalCompetition(competition?.type) ? `/competition/` : `/competition-job/`) + `${competition.id}${value.url}`
                    navigate(url);
                } else {
                    setSection(value)
                }
            }
        }
    }

    if (isLoading) {
        return (
            <div className="w-full flex align-items-center">
                <ProgressSpinner />
            </div>
        );
    } else {
        return (
            <>
                <div className='col-12 flex flex-row justify-content-between'>
                    <h3 className='mb-1 font-weight-normal'>{competition?.name}</h3>
                    {CompetitionUtils.isJobCompetition(competition?.type) &&
                        <div className='ml-3'>
                            <div className={`inline-block status status-competition-${competition?.status?.toLowerCase()}`}>
                                {CompetitionUtils.getCompetitionStatus(competition)}
                            </div>
                        </div>
                    }
                </div>
                <SelectButton
                    value={section}
                    options={sections}
                    onChange={(e) => handleSelectButtonChange(e.value)}
                    itemTemplate={navigationTemplate}
                    className="pcn-selectbutton mb-3"
                />

            </>
        );
    }
};

export default CompetitionToolbar;
